// extracted by mini-css-extract-plugin
export var container = "_5t-0";
export var infoButton = "_5t-1";
export var label = "_5t-3";
export var labelExpanded = "_5t-4";
export var price = "_5t-5";
export var priceExpanded = "_5t-6";
export var title = "_5t-2";